
import React, {  useEffect } from "react";
import configSettings from './../../config.js';

export default function SsoRedirect() {
  useEffect(() => {

    window.open('https://sso.blinds.com/dag/saml2/idp/SSOService.php?spentityid='+configSettings.serviceProviderEntityId,'_self')
  }, []);

  return (
    <div>
       Redirecting to SSO login page....
    </div>
  )
}
